// Icons
// import Analytics from '../assets/svg/analytics.svg?react'
import Icons from '../assets/svg/icons.svg?react'
import Links from '../assets/svg/link.svg?react'
import Settings from '../assets/svg/settings.svg?react'
import Design from '../assets/svg/swatch.svg?react'

export const links = [
  { to: '/links', icon: <Links width={30} />, text: 'Links' },
  { to: '/icons', icon: <Icons width={30} />, text: 'Icons' },
  { to: '/design', icon: <Design width={30} />, text: 'Design' },
  // { to: '/analytics', icon: <Analytics width={30} />, text: 'Analytics' },
  { to: '/settings', icon: <Settings width={30} />, text: 'Settings' },
]
